import { XStylesSettings } from '@shared/types/types';
import { OverlayProps } from '../model/types';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

const RadioButton = (props: OverlayProps) => {
  const { active = false, settings, children } = props;

  return (
    <>
      <div {...stylex.props([styles.base(active), settings as XStylesSettings])}>{children}</div>
    </>
  );
};

export default RadioButton;
